var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { SchoolLog as SchoolLogModel } from '@/models/SchoolLog';
import { mergeWith } from 'lodash';
import { DateTime } from 'luxon';
import { Component, Prop, Vue } from 'vue-property-decorator';
import InlineEditable from '@/components/InlineEditable/InlineEditable';
let SchoolLog = class SchoolLog extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isEditing = false;
        this.message = '';
        this.isUpdating = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    created() {
        this.message = this.log.clone().message;
    }
    // #endregion
    // #region Class methods
    trasnformDate(date) {
        const dateInstance = DateTime.fromSQL(date);
        if (this.isToday(dateInstance)) {
            return `${this.$tc('today')}, ${dateInstance.toFormat('HH:mm')}`;
        }
        if (this.isYesterday(dateInstance)) {
            return `${this.$tc('yesterday')}, ${dateInstance.toFormat('HH:mm')}`;
        }
        return dateInstance.toFormat('dd-LL-yyyy HH:mm');
    }
    isToday(date) {
        return date.toISODate() === DateTime.local().toISODate();
    }
    isYesterday(date) {
        return date.toISODate() === DateTime.local().minus({ days: 1 }).toISODate();
    }
    toggleEditState() {
        this.isEditing = !this.isEditing;
        if (!this.isEditing) {
            this.message = this.log.clone().message;
        }
    }
    async update() {
        this.isUpdating = true;
        const response = await this.log
            .update({ message: this.message })
            .catch(() => {
            this.isUpdating = false;
            return null;
        });
        if (response) {
            // We need to keep current meta since we are syncing the obj
            this.$emit('update:log', mergeWith(response, this.log, keepOriginalMeta));
            this.isEditing = false;
        }
        this.isUpdating = false;
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get isOwnLog() {
        return (this.log && this.log.user && this.log.user.id) === (this.$store.state.Auth && this.$store.state.Auth.id);
    }
    get name() {
        return (this.log && this.log.user && this.log.user.name) || this.$tc('anonymous');
    }
    get date() {
        if (!this.log.created_at) {
            return this.$tc('no_date');
        }
        const date = this.trasnformDate(this.log.created_at);
        if (this.log.updated_at !== this.log.created_at) {
            return `${date} - Laatst gewijzigd op ${this.trasnformDate(this.log.updated_at)}`;
        }
        return date;
    }
    get avatar() {
        return (this.log && this.log.user && this.log.user.avatar) || '';
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof SchoolLogModel !== "undefined" && SchoolLogModel) === "function" ? _a : Object)
], SchoolLog.prototype, "log", void 0);
SchoolLog = __decorate([
    Component({
        components: {
            InlineEditable,
        },
    })
], SchoolLog);
export default SchoolLog;
function keepOriginalMeta(objValue, srcValue, key) {
    if (key === 'meta') {
        return srcValue;
    }
    return objValue;
}
